import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpModule } from '@angular/http';
import { RouterModule, Routes } from '@angular/router';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MomentModule } from 'angular2-moment';
import { CountoModule } from 'angular2-counto';
import { JasperoAlertsModule } from '@jaspero/ng2-alerts';
import { JasperoConfirmationsModule } from '@jaspero/ng2-confirmations';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { AmChartsModule } from "@amcharts/amcharts3-angular";
import { NgSlimScrollModule } from "../../node_modules/ngx-slimscroll/src/ngx-slimscroll/module/ngx-slimscroll.module";
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ModalModule, BsDropdownModule, TooltipModule } from 'ngx-bootstrap';
import { BusyModule } from 'angular2-busy';
import { UiSwitchModule } from 'ngx-ui-switch';

import { BrightServeModule } from "app/brightserve/brightserve.module";
import { SharedModule } from "app/shared/shared.module";

// Common Features Module
import { BrightServeCommonModule } from './common/brightserve-common.module'; // TODO: REmove this dependency
import { AddonModule } from "app/add-ons/addon.module";

import { AdminAreaModule } from "app/admin/admin-area.module";
import { CaseModule } from "app/case/case.module";
import { ClientsModule } from "app/clients/clients.module";
import { DashboardModule } from "app/dashboard/dashboard.module";
import { PersonModule } from "app/person/person.module";
import { SecurityModule } from "app/security/security.module";
import { DoctorModule } from "app/doctor/doctor.module";
import { AdminUserModule } from "app/adminuser/adminuser.module";
import { ReferenceLibraryModule } from "app/library/reference-library.module";

import { ObjectTypePipe } from "app/brightserve/pipes/object-type.pipe";

import { AppComponent } from './app.component';
import { NavigationComponent } from './navigation/navigation.component';

import { UnreadNotificationsPipe } from './navigation/pipes/unread-notifications.pipe';

const AppRoutes: Routes = [
	{ path: '', redirectTo: '/dashboard', pathMatch: 'full' }
];

@NgModule({
	declarations: [
		AppComponent,
		ObjectTypePipe,
		NavigationComponent,
		UnreadNotificationsPipe
	],
	imports: [
		BrowserModule,
		FormsModule,
        HttpModule,
		NgbModule.forRoot(),
		JasperoAlertsModule,
		JasperoConfirmationsModule,
		SimpleNotificationsModule.forRoot(),
		AmChartsModule,
		BrowserAnimationsModule,
		MomentModule,
		CountoModule,
		NgSlimScrollModule,
		InfiniteScrollModule,
		ModalModule.forRoot(),
		BsDropdownModule.forRoot(),
        TooltipModule.forRoot(),
        BusyModule,
        UiSwitchModule,
		RouterModule.forRoot(
			AppRoutes,
			{
				enableTracing: false, // <-- debugging purposes only
				useHash: true
			}
		),

        BrightServeCommonModule,
		BrightServeModule,
        SharedModule,
        AddonModule,

		AdminAreaModule,
        ClientsModule,
        CaseModule,
        DashboardModule,
		PersonModule,
		SecurityModule,
        DoctorModule,
        AdminUserModule,
        ReferenceLibraryModule

	],
    providers: [
        //{ provide: LOCALE_ID, useValue: "utc" },
    ],
    bootstrap: [AppComponent],
	exports: [
		ObjectTypePipe
	]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts